import apiClient from './client';

export const listInvoices = (params) => apiClient.get('/invoices', { params }).then((r) => r.data);
export const getInvoice = (id) => apiClient.get(`/invoices/${id}`).then((r) => r.data);
export const createInvoice = (payload) => apiClient.post('/invoices', payload).then((r) => r.data);
export const updateInvoice = (id, payload) => apiClient.put(`/invoices/${id}`, payload).then((r) => r.data);
export const deleteInvoice = (id) => apiClient.delete(`/invoices/${id}`).then((r) => r.data);
export const sendInvoiceToClient = (id) => apiClient.post(`/invoices/${id}/send`).then((r) => r.data);

// The PDF endpoint requires the same Bearer token as every other API call, so it
// can't be hit as a plain <a href> link (that sends no auth header at all and the
// server replies "No token provided"). Fetch it through apiClient as a blob instead,
// then hand the browser a temporary object URL to open/download.
export const downloadInvoicePdf = (id, invoiceNumber) =>
  apiClient.get(`/invoices/${id}/pdf`, { responseType: 'blob' }).then((r) => {
    const blobUrl = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${invoiceNumber || 'invoice'}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  });
